import PageLayout from "@/components/layout/PageLayout";
import { LifeHero } from "@/components/insurance/life/LifeHero";
import { LifeCoverage } from "@/components/insurance/life/LifeCoverage";
import { LifeFeatures } from "@/components/insurance/life/LifeFeatures";
import Cities from "@/components/sections/Cities";

const LifeInsurancePage = () => {
  return (
    <PageLayout>
      <LifeHero />
      <LifeCoverage />
      <LifeFeatures />
      <Cities />
    </PageLayout>
  );
};

export default LifeInsurancePage;